import { render, staticRenderFns } from "./IconUserCheck.vue?vue&type=template&id=f5c63bc2"
import script from "./IconUserCheck.vue?vue&type=script&lang=js"
export * from "./IconUserCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports